import { axios } from '@/lib/axios';
import { useMutation, useQueryClient } from 'react-query';
import { useNotificationStore } from '@/stores/notifications';

export const deleteTranslation = async (keysToDelete: number[]) => {
    for (const id of keysToDelete) {
        await axios.delete(`/api/admin/site_translation/${id}`);
    }
};

export const useDeleteTranslation = (closeModalFunction: () => void) => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotificationStore();

    return useMutation({
        onError: (_, __, context: any) => {
            addNotification({
                type: 'error',
                title: 'Unable to delete translation',
            });
            closeModalFunction();
        },
        onSuccess: () => {
            queryClient.refetchQueries(['translation']);
            queryClient.invalidateQueries(['translation']);
            closeModalFunction();
            addNotification({
                type: 'info',
                title: 'The value was successfully updated',
            });
        },
        mutationFn: deleteTranslation,
    });
};
